const mapDataBundleToRelatedDataset = (item: MarketplaceDataset[]) => {
    const dataProfiles: DataProfile[] = [];
    const marketDatasetDatasets: MarketDatasetDataset[] = [];
    const dataProviders: Set<string> = new Set<string>();

    if (item && item.length > 0) {
        item.filter(relatedDataset => { if (!relatedDataset.MarketplaceDataset) return true; return relatedDataset.MarketplaceDataset.ActiveMPDatasetCoverage; }).forEach(relatedDataset => {
            marketDatasetDatasets.push({ ...relatedDataset, KeyMarketplaceDatasetRelated: relatedDataset.KeyMarketplaceDataset, KeyMarketplaceDatasetBundle: relatedDataset.KeyMarketplaceDatasetBundleRel });
        });
    }

    const bundleLogos: MarketDatasetLogos[] = [];

    return {
        marketDatasetVisualization: [],
        name: '',
        id: 0,
        isBundle: true,
        addedDate: '',
        enhancementDate: '',
        shortDescription: '',
        thumbnailImageFilePath: '',
        longDescription: '',
        dataProviderDesc: '',
        bundleDatasets: dataProfiles,
        releaseNote: '',
        releaseNoteTitle: '',
        marketDatasetResearchs: [],
        marketplaceTrialButtonTitle: '',
        dataProvider: [...dataProviders].join(', '),
        earliestRecord: 0,
        pointInTime: false,
        aiReady: null,
        onlineImageFilePath: '',
        socialSharingImageFilePath: '',
        earliestSignificantCoverage: 0,
        estimatedDatasetSize: 0,
        estimatedDatasetStorage: 0,
        marketplaceDatasetCoverageDesc: '100',
        marketplaceDataSource: '',
        overviewImageFilePath: '',
        pointInTimeDescription: '',
        marketDatasetDatasets,
        marketDatasetSearchTags: [],
        marketDatasetMIIndustrys: [],
        marketDatasetGeographys: [],
        marketDatasetLinks: [],
        marketDatasetNotebooks: [],
        deliveryChannel: [{ SPGDestinationPlatform: '', KeySPGDestinationPlatform: 0 }],
        deliveryPlatform: [{ SPGDestinationPlatform: '', KeySPGDestinationPlatform: 0 }],
        marketplaceDatasetFieldCount: { MarketplaceDatasetFieldCount: '' },
        supportDocs: [],
        marketDatasetLogos: bundleLogos,
        hasAlert: false,
        alertNote: '',
        alertTitle: '',
        active: false,
        marketMSADataLink: '',
        marketMSADataFilePath: '',
        marketplaceMSATooltip: '',
        mktplaceSolutionSupportEmail: '',
        marketSPGDeliveryPlatform: [],
        marketSPGDestinationPlatform: [],
        isType: 'Bundle',
        keySPGDeliveryPlatform: '',
        sPGDeliveryPlatform: '',
        activeMarketPlaceSearchTag: ''
    } as DataProfile;
};
export default mapDataBundleToRelatedDataset;
